<template>
	<div class="menu-wrap">
		<transition-group>
			<template v-for="item in routes" v-if="!item.hidden && item.children">
				<router-link
					v-if="hasOneShowingChildren(item) && (!showingChild(item).children || showingChild(item).alwaysShow)"
					:to="{path: (showingChild(item).alwaysShow ? '' : item.path + '/') + showingChild(item).path, query: {trigger: 'nav'}}"
					:key="showingChild(item).name">
					<el-menu-item :index="(showingChild(item).alwaysShow ? '' : item.path + '/') + showingChild(item).path" class="submenu-title-noDropdown">
						<svg-icon v-if="item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
						<span v-if="showingChild(item).meta && showingChild(item).meta.title" slot="title">{{ showingChild(item).meta.title }}<svg-icon class="tips-icon" v-if="item.meta.tipsIcon" :icon-class="showingChild(item).meta.tipsIcon" :class-name="showingChild(item).meta.tipsIcon" :tips="showingChild(item).meta.tips"></svg-icon></span>
					</el-menu-item>
				</router-link>

				<router-link v-else-if="item.alwaysShow" :to="{path: item.path, query: {trigger:'nav'}}" :key="item.name">
					<el-menu-item :index="item.path" class="submenu-title-noDropdown">
						<svg-icon v-if="item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
						<span v-if="item.meta.title" slot="title">{{ item.meta.title }}<svg-icon class="tips-icon" v-if="item.meta.tipsIcon" :icon-class="item.meta.tipsIcon" :class-name="item.meta.tipsIcon" :tips="item.meta.tips"></svg-icon></span>
					</el-menu-item>
				</router-link>

				<el-submenu v-else :index="item.name || item.path" :key="item.name">
					<template slot="title">
						<svg-icon v-if="item.meta && item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
						<span v-if="item.meta && item.meta.title" slot="title">{{ item.meta.title }}<svg-icon class="tips-icon" v-if="item.meta.tipsIcon" :icon-class="item.meta.tipsIcon" :class-name="item.meta.tipsIcon" :tips="item.meta.tips"></svg-icon></span>
					</template>

					<template v-for="child in item.children" v-if="!child.hidden">
						<sidebar-item :is-nest="true" class="nest-menu" v-if="child.children && !!child.children.length" :routes="[child]" :key="child.path"></sidebar-item>

						<router-link v-else :to="{path: item.path + '/' + replaceParams(child.path), query: {trigger: 'nav'}}" :key="child.name">
							<el-menu-item :index="item.path + '/' + replaceParams(child.path)">
							<svg-icon v-if="child.meta && child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
							<span v-if="child.meta && child.meta.title" slot="title">{{ child.meta.title }}<svg-icon class="tips-icon" v-if="child.meta.tipsIcon" :icon-class="child.meta.tipsIcon" :class-name="child.meta.tipsIcon" :tips="child.meta.tips" :tipsStyle="child.meta.tipsStyle"></svg-icon></span>
							</el-menu-item>
						</router-link>
					</template>
				</el-submenu>
			</template>
		</transition-group>
	</div>
</template>

<script>

export default {
	name: 'SidebarItem',
	props: {
		routes: {
			type: Array
		}
	},
	computed: {
		showingChild(item) {
			return function(item) {
				const showingChildren = item.children.filter(child => {
					return !child.hidden
				})
				return showingChildren[0]
			}
		}
	},
	methods: {
		hasOneShowingChildren(item) {
			const children = item.children
			const showingChildren = children.filter(child => {
				return !child.hidden
			})
			if (showingChildren.length === 1) {
				if (item.meta.title) {
					this.$store.dispatch('setHideBreads', item.meta.title)
				}
				return true
			}
			return false
		},

		replaceParams(path) {
			const pos1 = path.indexOf(':');
			if (pos1 > 0) {
				const pos2 = path.indexOf("/", pos1);
				if (pos2 === -1) {
					return path.replace(path.substring(pos1), 0);
				} else {
					const str = path.replace(path.substring(pos1, pos2), 0);
					return this.replaceParams(str)
				}
			} else {
				return path;
			}
		}
	}
}
</script>

